/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Router from '@ember/routing/router-service';

export default class FinAIAgentIndexRoute extends Route {
  @service declare router: Router;

  beforeModel() {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.setup');
  }
}
